const data=[
    {
        name:"Bioderma Atoderm Huile De Douche 24h Hydration Ultra-Nourishing Anti-",
        category:"skin",
        description:"Bestow the gift of glow to your skin with FACES Bath N Body Milk & Honey Body Scrub, crafted with organically sourced ingredients to keep the skin naturally nourished and radiant. One of the truly luxurious palette of personal care products", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/9/7/974e43ebiode00000007-01.jpg",
        price:200,
        ofPrice:300,
        quantity:10
    },
    {
        name:"Plum BodyLovin' Vanilla Vibes Body Oil",
        category:"skin",
        description:" Plum is inspired by the goodness in nature, and driven by the desire to be good and do good. Designed in a London studio, Plum products are always 100% vegan and cruelty-free. No parabens, phthalates or other doubtful - in any product. Marrying science and product expertise with innate love for nature, welcome to plum. Take in the goodness!", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/6/2/62446568906118410798_1.jpg",
        price:209,
        ofPrice:350,
        quantity:11
    },
    {
        name:"Dove Body Love Pro Age Body Butter, For Mature Skin, Paraben Free",
        category:"skin",
        description:"Dove loves your body unconditionally. Dove knows that mature skin can be tricky and it’s not always easy to keep your skin feeling and looking its best. Mature Skin losses moisture faster & becomes dry & dull fast. Your Skin needs a specially crafted body lotion for superior care that works on the skin from inside as well as outside Presenting Dove Body Love Pro Age Body Butter. A unique solution to manage your mature skin. ", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/3/d/3dd79e8dovex00000087_new_4.jpg",
        price:200,
        ofPrice:300,
        quantity:10
    },
    {
        name:"Bioderma Atoderm Huile De Douche 24h Hydration Ultra-Nourishing Anti-",
        category:"skin",
        description:"Bestow the gift of glow to your skin with FACES Bath N Body Milk & Honey Body Scrub, crafted with organically sourced ingredients to keep the skin naturally nourished and radiant. One of the truly luxurious palette of personal care products", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/9/7/974e43ebiode00000007-01.jpg",
        price:200,
        ofPrice:300,
        quantity:10
    },
    {
        name:"Mamaearth Vitamin C Underarm Scrub With Vitamin C And Turmeric For Brighter Underarms",
        category:"skin",
        description:"Worried about pigmented underarms? Now’s the time to put your arms up and celebrate because Mamaearth Vitamin C Underarm Scrub is here. Made with volcanic clay beads, the scrub exfoliates your underarm skin and helps get rid of dark spots and blemishes.", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/9/e/9e8384e8906087778424_8.jpg",
        price:270,
        ofPrice:390,
        quantity:13
    },
    {
        name:"Biotique Bio Apricot Refreshing Body Wash - 800ml",
        category:"skin",
        description:"Apricot is one of the most nutritious, centuries-old fruits, rich in vitamins, especially vitamin E and A, linoleic acid, oleic acid, and minerals known for their revitalizing powers. Its light, absorbent nature makes it an ideal moisturizer and anti-aging agent to improve elasticity, skin clarity and suppleness, It improves skin complexion and reduces dark circles.It has antioxidant properties.", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/f/f/ffa10fb8906009452111_1.jpg",
        price:200,
        ofPrice:300,
        quantity:15
    },
    {
        name:"Olay Ultra Moisture Body Wash With Avocado Oil",
        category:"skin",
        description:"Reveal beautiful, healthy-looking skin with Olay Ultra Moisture Body Wash with Avocado Oil. Now formulated with Olay’s Vitamin B3 Complex, it hydrates to plump surface skin cells, locking in natural moisture. The advanced formula, with avocado oil and Olay moisturizers, wraps your skin in a lush fragrance and leaves skin hydrated and silky smooth to the touch. A hydrating shower gel that moisturizes your skin gently and cleanses like no other!", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/9/e/9eb2e2d37000524090.jpg",
        price:200,
        ofPrice:300,
        quantity:13
    },
    {
        name:"Aroma Magic Mineral Glow Scrub (All Skin Types)",
        category:"skin",
        description:"The Aroma Magic Mineral Glow Scrub is quite a must-have! Its triple action scrub formula, made of natural exfoliators of Cornflower and grain Almond meal, gently buffs away dry skin and dead cells resulting in fresh, young, energized and healthy skin. Rice bran oil and aqua minerals remineralizer and enrich your skin reducing fine lines effectively.", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/a/r/aroma_magic_mineral_glow_scrub_2000x.jpg",
        price:390,
        ofPrice:500,
        quantity:19
    },
    {
        name:"WOW Skin Science Ubtan Body Wash",
        category:"skin",
        description:"Ubtan - the beauty secret of the queens, courtesans, ladies and brides of yore – is a paste made with herbs, oils, natural powders and extracts. Ubtans are traditional ayurvedic beauty and wellness recipes meant to rejuvenate skin, body and mind. In the olden days, applying Ubtan was ritualistic. ", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/d/c/dcc62fd8904311902386_1.jpg",
        price:450,
        ofPrice:780,
        quantity:17
    },
    {
        name:"Lotus Professional Retemin Plant Retinol & Vitamin C Brightening Boost Night Cream",
        category:"skin",
        description:"Lotus Professional Retimen Plant Retinol + Vitamin-C Brightening Boost Night Cream with natural vitamin C derived from kakadu plum and bakuchiol extracts (plant retinol) helps charge your skin to let you take on your day with confidence. It locks moisture into your skin to let you wake up with fresh skin that glows from within. ", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/3/b/3b741delotaa00000044_nv1.jpg",
        price:450,
        ofPrice:710,
        quantity:11
    },
    {
        name:"O3+ Derma Cult Resurfacing Energy Facial Peel For Instant Brightening + Adaptogen",
        category:"skin",
        description:"O3+ Derma Cult Resurfacing Energy Facial Peel is a gentle exfoliater that is enriched with adaptogens like ginseng and goji berry which is backed by Eastern medicine and Ayurveda for over 5000 years. This facial peel is an instant brightening solution for every type of skin.", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/4/e/4e33271o3-0951_7_.jpg",
        price:450,
        ofPrice:780,
        quantity:12
    },
    {
        name:"O3+ Sara Ayurveda Kumkumadi Brightness Facial Kit For Bridal Glow",
        category:"skin",
        description:"The kumkumadi oil blended in this facial is known as kumkumadi tailam, it is a creation of many different herbs which all come together and work as a mystic method to cure skin issues. The oil, which can also be used as a moisturizer is suitable for almost all skin types specifically for sensitive or dry flaky skin.", 
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/c/6/c6f2409o3xxx00000114_0.jpg",
        price:230,
        ofPrice:470,
        quantity:15
    },
    {
        name:"Chicco Baby Moments Rich Cream",
        category:"Mom&BabyCare",
        description:"The new baby toiletries line baby moments is born! A complete range of products for everyday care of baby's sensitive and delicate skin. Every day, from the first day. The rich cream contains oils rich in Omega-3 and Vitamin E and nourishes baby's skin deeply, thanks to its highly moisturising formula and the rich texture. Particularly suitable for dry areas.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/b/e/be80db28058664152490_1.jpg",
        price:350,
        ofPrice:350,
        quantity:12
    },
    {
        name:"Chicco Baby Moments Mild Bodywash Protect",
        category:"Mom&BabyCare",
        description:"The all new Chicco Baby Moment Mild Body Wash Protect is a new age solution for a baby’s Body Wash which keeps skin highly moisturized, soft and soothing after bath. The Body Wash formula is a special mild formula developed for bathing a baby’s body and skin.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/0/8/088a1068058664152308_1.jpg",
        price:479,
        ofPrice:441,
        quantity:17 
    },
    {
        name:"Chicco Body Lotion",
        category:"Mom&BabyCare",
        description:"The new baby toiletries line baby moments is born! A complete range of products for everyday care of baby's sensitive and delicate skin. Every day, from the first day. Body lotion moisturises baby's skin, making it wonderfully smooth and soft.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/37253e89591b79b38c00254331932999/4/4/443d5b28058664152391-1.jpg",
        price:499,
        ofPrice:470,
        quantity:13 
    },
    {
        name:"Chicco Gentle Body Wash And Shampoo - 500ml",
        category:"Mom&BabyCare",
        description:"The new baby toiletries line baby moments is born! A complete range of products for everyday care of baby's sensitive and delicate skin. Every day, from the first day. Gentle Body Wash and Shampoo formula gently cleanses delicate baby's skin, since the first baths. With soothing and softening oat properties. No-tears formula does not irritate the eyes and the absence of parabens, SLS and SLES guarantees extra-care for the delicate skins of newborns. The iso-lachrymal neutral pH (pH 7) is ideal for newborns, starting from the earliest bath.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/d/c/dc91b1e8058664152254_1.jpg",
        price:499,
        ofPrice:470,
        quantity:14
    },
    {
        name:"Chicco Natural Sensation Bath Shampoo - 300ml",
        category:"Mom&BabyCare",
        description:"Chicco Natural Sensation is the new line studied to follow the natural development process of baby's skin. All formulas are inspired by the Vernix Caseosa composition, offering natural protection during pregnancy to cleanse, protect and nurture the baby's skin. ",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/7/c/7c213988058664066612_main_3_1.jpg",
        price:649,
        ofPrice:584,
        quantity:18 
    },
    {
        name:"Himalaya Gentle Baby Shampoo",
        category:"Mom&BabyCare",
        description:"Himalaya Gentle Baby Shampoo is enriched with natural sources of protein that leave your baby's hair soft and nourished. This mild baby shampoo is formulated to cleanse and strengthen your little one's hair without any teary-eyed blues. It is a natural shampoo containing no harsh chemicals and boasts anti-inflammatory and soothing properties to protect and care for your baby's tender scalp.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/u/n/untitled-46.jpg",
        price:320,
        ofPrice:320,
        quantity:15 
    },
    {
        name:"Cetaphil Baby Massage Oil With Shea Butter",
        category:"Mom&BabyCare",
        description:"Cetaphil Baby Massage Oil is created with care to provide your child with the proper nourishment which is required for their growth and development.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/c/0/c00c21e9318637043323_1.jpg",
        price:630,
        ofPrice:599,
        quantity:12
    },
    {
        name:"Mamaearth Foaming Face Wash For Kids With Aloe Vera & Coconut For Gentle Cleansing",
        category:"Mom&BabyCare",
        description:"Mamaearth Foaming Face Wash for Kids is here to gently cleanse and nourish your little one's skin. With its superpowers, it washes away dirt and grime, keeping harmful bacteria at bay. It's Made Safe Certified and contains the goodness of aloe vera and coconut, which provide deep moisturization and nourishment to your child's delicate skin. ",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/d/b/dbcab848906087778264_7.jpg",
        price:349,
        ofPrice:349,
        quantity:11 
    },
    {
        name:"Mamaearth Coco Soft Massage Oil For New Born With Coconut & Turmeric Oil",
        category:"Mom&BabyCare",
        description:"Mamaearth Coco Soft Massage Oil strengthens your bond with your baby. They ensure that massage time is fun and relaxing for your baby and completely safe. It nourishes your baby's skin with a natural blend of goodness and non-sticky formula. Crafted with coconut oil, it deeply moisturises your baby's delicate skin while keeping infections at bay.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/c/o/coco-oil.jpg",
        price:399,
        ofPrice:339,
        quantity:12 
    },
    {
        name:"Lotus Herbals Baby+ Gentle Cleansing Shampoo PH 5.5 Sulphate Free",
        category:"Mom&BabyCare",
        description:"Lotus Herbals Baby+ Gentle Cleansing Shampoo is a unique natural formula that blends chamomile and calendula extracts into a rich bathing experience. It gently cleanses hair, promoting healthy baby hair. Wrap your bundle of joy in the pristine care of all things natural. Brought to life with handpicked ingredients sourced from rare plants, herbs and flowers.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/e/z/ezgif-1-d79c0a9971.jpg",
        price:355,
        ofPrice:309,
        quantity:14
    },
    {
        name:"Lotus Herbals BABY LITTLE Bubbles Body Wash & Shampoo",
        category:"Mom&BabyCare",
        description:"Wrap your bundle of joy in the pristine care of all things natural. Brought to life with handpicked ingredients sourced from rare plants, herbs and flowers, Lotus Herbals baby+ Little Bubbles Body Wash & Shampoo is as safe as nature itself. This unique natural formula has blends of chamomile extract that work into a rich bathing experience. ",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/e/z/ezgif-1-7bba281fb8.jpg",
        price:345,
        ofPrice:293,
        quantity:17 
    },
    {
        name:"Lotus Herbals Baby + Tender Touch Baby Body Lotion",
        category:"Mom&BabyCare",
        description:"Wrap your bundle of joy in the pristine care of all things natural. Brought to life with handpicked ingredients sourced from rare plants, herbs and flowers Lotus Herbals Baby+ Tender Touch Baby Body Lotion soothes dry, delicate skin. This formula absorbs quickly and has a non greasy formula that penetrates smoothly for long lasting moisture and protection against dry baby'skin. ",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/e/z/ezgif-1-51694c1def.jpg",
        price:245,
        ofPrice:245,
        quantity:18 
    },
    {
        name:"Mamaearth Organic Bamboo Based Baby Wipes And Travel Pack",
        category:"Mom&BabyCare",
        description:"Keep your baby's soft and sensitive skin squeaky clean with Mamaearth's India's First Organic Bamboo Based Baby Wipes! From changing diapers to cleaning up after a messy meal, these delicate and safe wipes come handy at all times. They are enriched with vitamin E, shea butter, almond oil and aloe vera to nourish your baby's skin while cleansing it. Mamaearth's travel friendly baby wipes are an environment-friendly biodegradable alternative to traditional polyester based wet wipes! These are perfectly suitable for everyday use on soft and sensitive skin.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/m/m/mmm199.jpg",
        price:348,
        ofPrice:290,
        quantity:12 
    },
    {
        name:"Chicco Baby Moment Gift Pack - Blue In",
        category:"Mom&BabyCare",
        description:"Chicco's Baby Moments Gift Pack is the perfect way to give a bundle of blessings to your little one. The gift pack contains all the necessary products that are characterised by safe formulations to cleanse, nourish and protect your baby's delicate skin from their very first day and moments.The products under Baby Moments are delicate, hypoallergenic, clinically-tested and paraben-free.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/b/b/bbj0001888-1.jpg",
        price:1100,
        ofPrice:968,
        quantity:19 
    },
    {
        name:"KamaSutra Thrill Deodorant",
        category:"Fragrance",
        description:"Make every woman's heart skip a beat, with just one look. Entice the woman of your dreams with an exciting new fragrance, the KamaSutra Thrill Deodorant! This deodorant carries subtle hints of patchouli, vanilla and rustic amber, that will send hearts racing!",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/u/n/untitled-1_6.jpg",
        price:440,
        ofPrice:396,
        quantity:18
    },
    {
        name:"KamaSutra Blaze Deodorant - Pack Of 2",
        category:"Fragrance",
        description:"Crafted by International experts, KamaSutra Blaze Deodorant is a unique fusion fragrance to fan the fire of passion. This long-lasting deodorant amps up the fervor with its woody, leathery and fruity notes. It keeps body odour and bacteria away.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/u/n/untitled-1_5.jpg",
        price:440,
        ofPrice:396,
        quantity:14
    },
    {
        name:"KamaSutra Urge Power Series Perfume Spray- Pack Of 2",
        category:"Fragrance",
        description:"Furtive eye-contact. Longing glances. Seductive gestures. Non-stop flirting. And the man who is the objective of every woman's desire. These are just some of the benefits of the warm and sensual KamaSutra Urge Power Series Perfume Spray!",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/u/n/untitled-1_4_3.jpg",
        price:440,
        ofPrice:396,
        quantity:12
    },
    {
        name:"KamaSutra Woman Sparkle Perfume Body Spray",
        category:"Fragrance",
        description:"KamaSutra Woman Sparkle Perfume Body Spray is specially crafted by International experts. It has a long-lasting fragrance and keeps your fresh and confident throughout the day. It also helps to fight body odor and keep bacteria away.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/u/n/untitled-1_4_1.jpg",
        price:398,
        ofPrice:398,
        quantity:14
    },
    {
        name:"KamaSutra Woman Enigma Perfume Body Spray - Pack Of 2",
        category:"Fragrance",
        description:"Awaken your senses with sizzling fusion of floral-fruity notes. KamaSutra Woman Enigma Perfume Body Spray is a refreshing body spray for women, crafted by International experts. It has a long-lasting fragrance and keeps your fresh and confident throughout the day. It also helps to fight body odor and keep bacteria away.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/u/n/untitled-1_2_1.jpg",
        price:398,
        ofPrice:398,
        quantity:15
    },
    {
        name:"Plum Bodylovin' Feelin' So Rose Body Mist",
        category:"Fragrance",
        description:"Picture this. You're gliding' through freshly bloomed rose valleys and take a whiff. But wait, this ain't no ordinary rose fragrance! Can you really ever say no to an aloe-infused musky twist?",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/5/5/55c1d29plumx00000130_5_1.jpg",
        price:525,
        ofPrice:457,
        quantity:17
    },
    {
        name:"Plum Bodylovin' Orchid You Not Body Mist",
        category:"Fragrance",
        description:"Be-leaf us, one whiff of this humor, love, aloe and orchids infused scintillating' fragrance and you won't be able to stop spritizin'! Plum BodyLovin' Orchid You Not Body Mist is a refreshing aloe-infused formula that keeps you feeling fresh, nourished and in a good mood. This subtly sweet and exciting fragrance will make you reminisce peppy orchids bathed in soft sunlight with every spritz.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/2/6/266b211plumx00000054_1.jpg",
        price:525,
        ofPrice:473,
        quantity:16
    },
    {
        name:"Mamaearth Eau De Parfum For A Fragrance As Unique As You",
        category:"Fragrance",
        description:"Why be someone else when you can just be you? Introducing ME Eau De Parfum For a Fragrance As Unique As You, a perfume that lets you be you. It's unique because once you spritz it, it reacts differently with different people's skin oils and produces a scent that is absolutely one-of-a-kind and can't be replicated. A unisex perfume, this is the signature fragrance that you've been looking for. It's a scent that smells like you but better.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/9/f/9fd2fca8906087777243__1_.jpg",
        price:699,
        ofPrice:629,
        quantity:19
    },
    {
        name:"Mamaearth ME Deo For A Scent That's Unique To You",
        category:"Fragrance",
        description:"Celebrate your 'YOU-niqueness' with a fragrance that is as distinct and amazing as you! Introducing Mamaearth ME Deo, a unisex deodorant that mixes with your skin oils to produce a scent that’s one-of-a-kind, can’t be replicated and is unique to you. Nature-inspired, ME Deodorant features a fresh floral infusion enhanced with an earthy blend of Cashmeran & Musk. The warm woody undertones, sweet floral hints of Rose and the crisp citrusy notes of Neroli Accords evoke an effortless charm that keeps body odor at bay for up to 8 hours.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/m/e/me-deodorant.jpg",
        price:299,
        ofPrice:299,
        quantity:11
    },
    {
        name:"Calvin Klein Eternity For Men Eau De Parfum",
        category:"Fragrance",
        description:"Refined and sophisticated, Calvin Klein Eternity Eau de Parfum celebrates the concepts of modern masculinity. A new woody note reinvents the original fougère scent, providing crisp freshness with a powerful yet elegant trail.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/s/8/s8.jpg",
        price:3650,
        ofPrice:3468,
        quantity:12
    },
    {
        name:"Fogg Scent Xtremo Men Fragrance Body Spray",
        category:"Fragrance",
        description:"Express what you feel. Be who you are. Don't hide, don't run. Unleash the man in you with Fogg Scent Xpression. Bold, masculine and absolutely sexy, there are no two ways of doing this right. Bury your fears, lift up that smile and head for your wild, wild side.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/f/o/fo6.jpg",
        price:599,
        ofPrice:539,
        quantity:17
    },
    {
        name:"Engage Yin Eau De Parfum For Men",
        category:"Fragrance",
        description:"Extremely fresh sparkling green citrus fragrance with hints of earthy woody notes. Perfect for a man who is suave and confident. The lasting fragrance comes with the essence of sophisticated ambers and rich patchouli, which will leave an unforgettable trail wherever you go.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/e/5/e55.jpg",
        price:499,
        ofPrice:459,
        quantity:19
    },
    {
        name:"Vaadi Herbals Aloe Vera Face Scrub",
        category:"Ayurveda",
        description:"This uniquely made Facial Scrub gently cleanses facial skin without removing moisture and makes the skin appear baby soft and pampered.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/1/8/18_12_3.jpg",
        price:285,
        ofPrice:285,
        quantity:17
    },
    {
        name:"Vaadi Herbals 24 Carat Gold Massage Gel With 24 Carat Gold Dust & Grape Seed Extract",
        category:"Ayurveda",
        description:"Made with 24 carat gold leaves extract along with Aloe Vera and Grape Seed extract, this unique Gold massage gel relaxes the facial skin and helps bring back lost hydration to tired looking skin.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/1/7/17_14_4.jpg",
        price:320,
        ofPrice:320,
        quantity:19
    },
    {
        name:"O3+ Volcano Scrub",
        category:"Ayurveda",
        description:"The O3+ Volcano Scrub suitable for normal to oily skin, helps in exfoliating the skin while reducing excess oil and removing black-heads and white-heads.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/o/4/o45.jpg",
        price:490,
        ofPrice:450,
        quantity:12
    },
    {
        name:"O3+ Milk Scrub Dry Skin Dermal Zone",
        category:"Ayurveda",
        description:"The O3+ Milk Scrub formulated with real milk, helps to moisturize & exfoliate the skin while removing black-heads and white-heads.How to use - Take a dab of the scrub and massage it all over the face. Don't rub it in too hard and avoid using around the eyes and breakouts. Use thrice a week.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/o/4/o41_1.jpg",
        price:490,
        ofPrice:431,
        quantity:16
    },
    {
        name:"Himalaya Herbals Oil-Free Radiance Gel Cream",
        category:"Ayurveda",
        description:"Himalaya herbals oil free radiance gel cream is a light and non greasy, daily use gel cream that gently hydrates to give an oil free radiant glow. It is a light gel textured cream enriched with special herbs that provides three essential benefits. Absorbs quickly into skin, hydrates skin, gives skin a natural radiance. Key ingredients: Barbary fig contains polysaccharides that provide moisture, winter melon exhibits antioxidant properties that keep skin healthy, protected and rejuvenated.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/2/8/288.jpg",
        price:260,
        ofPrice:260,
        quantity:18
    },
    {
        name:"Shahnaz Husain Shalocks Plus Ayurvedic Hair Oil",
        category:"Ayurveda",
        description:"A Non greasy Ayurvedic Hair Oil specially created to prevent hair loss and helps promote luxurious hair growth. Excellent combination of herbal oils and extracts, it facilitates the removal of loose dandruff. It revitalizes hair and makes them appear manageable, healthy and lustrous.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/s/7/s7.jpg",
        price:710,
        ofPrice:640,
        quantity:13
    },
    {
        name:"Shahnaz Husain Gold 2-In-1 Anti Ageing Gel",
        category:"Ayurveda",
        description:"Natures Gold Skin Radiance Gel comes along with a unique dual complex formula, containing 24 carat pure Gold, for slowing the visible sign of aging. It helps to revitalize and rejuvenate the skin surface, making the skin look younger and more radiant.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/s/1/s1_1.jpg",
        price:1955,
        ofPrice:1857,
        quantity:19
    },
    {
        name:"L'Oreal Paris Aura Perfect Scrub",
        category:"Ayurveda",
        description:"Exfoliating Beads: Washes away excess sebum at the skin's surface and helps to remove dull dead cells to reveal a more radiant complexion.Skin looks brighter: Reflects the light with its natural beauty.Unclogs pores and clears them from dirt and impurities.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/4/1/41glllfrqml._sl1001_.jpg",
        price:400,
        ofPrice:400,
        quantity:17
    },
    {
        name:"Biotique Bio Sea Weed Revitalizing Anti Fatigue Eye Gel",
        category:"Ayurveda",
        description:"Puffy eyes, shadow and dark circles are not something we desire as they take away the beauty of the face. This can happen due to stress, overwork, lack of sleep and excessive use of make-up. While you cannot do much about the stress and work, you can always take care of the puffiness and dark circles by using products that will deminish these marks. With ’Biotique Bio Sea Weed Revitalizing Anti Fatigue Eye Gel’ you can reduce the puffiness of the eyes along with the shadow and the dirk circle to a considerable level. The Biotique Anti Fatigue Eye Gel only requires a small amount and is enough to minimise the shadows and bulge around the eyes. ",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/b/2/b28.jpg",
        price:199,
        ofPrice:199,
        quantity:15
    },
    {
        name:"Cetaphil Sun SPF 30 Light Gel",
        category:"Ayurveda",
        description:"Cetaphil Sun makes sure you’re protected from UVA, UVB and Infrared Radiation both indoors and outdoors.Made with chemical and physical filters and a gel based formula that blends right into your skin.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/c/1/c1.jpg",
        price:1150,
        ofPrice:1070,
        quantity:13
    },
    {
        name:"Beeone Gold Facial Gel",
        category:"Ayurveda",
        description:"Oily and sensitive skin is the type where massage should be given with a perfect blend of water and moisturizer.This gel offers the right mixture of the same.This non-sticky gel gives freshness, relaxation and cooling effect.It protects the skin against sun damage and acts as a guard and immunizing agent against skin ailments like dry skin, acne and itchy skin conditions.It soaks out the sedimented oil, dirt and pollution form the pores, thereby making the skin smoother and shinier.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/b/e/be69.jpg",
        price:290,
        ofPrice:230,
        quantity:12
    },
    {
        name:"Plum Ban The Tan Combo - SPF50 + Face Scrub + Face Mask",
        category:"Ayurveda",
        description:"Get the right glow for your skin! No matter what - the hardworking ingredients in this clay face mask will get you the glow. Carefully sourced White Bentonite, Kaolin and the proprietary mixture of Chamomile extracts, White Tea Leaf extracts, Licorice root extract and 5 hyper-antioxidant leaf extracts come together in this glow-getter mask.",
        image:"https://www.beautybebo.com/pub/media/catalog/product/cache/9afc37bdf46fae888adf23d57cf627ad/p/l/pl64.jpg",
        price:1385,
        ofPrice:1260,
        quantity:11
        
    },
]
const Images=[
    "https://www.beautybebo.com/pub/media/ads/home-slider/Ponds_Forent_Banner_6-min.jpg",
    "https://www.beautybebo.com/pub/media/ads/home-slider/Slider_banner_1-min.jpg",
    "https://www.beautybebo.com/pub/media/ads/home-slider/Mamaearth_banner_1-min.jpg",
]
export {data,Images}